export const useErrors = () => {
  const errorId = useState<UUID | null>('errorId', () => null)
  const someError = useState('someError', () => false)
  const moreErrors = useState<boolean>('moreErrors', () => false)

  const customClearError = () => {
    errorId.value = null
    clearError()
  }

  return { moreErrors, clearError: customClearError, someError, errorId }
}
